import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useMultiLocationUtils } from '@frontend/payments-hooks';
import { Button, Text } from '@frontend/design-system';
import { styles } from './styles';

export const RowHeader = ({ firstName, lastName, locationIds }: GetPatientsBalanceResponse_PatientBalance) => {
  const { getLocationName } = useMultiLocationUtils();

  return (
    <>
      <div css={styles.rowHeader.container}>
        <Text as='span' weight='bold'>
          {firstName}
        </Text>
        <Text as='span'>{lastName}</Text>
        <Button
          css={styles.rowHeader.locationButton}
          iconName='location'
          variant='secondary'
          size='tiny'
          hoverLabel={getLocationName(locationIds[0] ?? '')}
          trackingId='collections-row-location-button'
        />
      </div>
    </>
  );
};
